export default __webpack_public_path__ + "static/joko-app-screenshot-home-4-fr@2x-fe379e38c83c494792848d2e2b4a9083.webp";